module.exports = __webpack_public_path__ + "assets/img/3.68f14490.svg";